module.exports = __webpack_public_path__ + "img/priorityTypes.d611f492.svg";